<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
                <el-breadcrumb-item>考勤月报</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id' highlight-current default-expand-all></el-tree>
            </div>
            <div class="main-table">
                <div class="table-head">
                  <div style="width:100%;display:flex;align-items:center;justify-content:space-between">
                    <!-- <div >
                      <span>出勤规则：</span>
                      <el-select
                        v-model="search.minValue"
                        clearable
                        filterable
                        placeholder="请选择最小时长"
                        class="select"
                        style="width:12vh;"
                      >
                        <el-option v-for="item in startDay" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select
                        v-model="search.maxValue"
                        clearable
                        filterable
                        placeholder="请选择最大时长"
                        style="margin-left:20px;width:12vh;"
                      >
                        <el-option v-for="item in endDay" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                    </div> -->
                       <div style="display:flex;align-items:center;width:30%;">
                        <span>人员检索：</span>
                        <div class="table-head-seach" style="margin-right:1%;display:flex;width:50%">
                            <el-input placeholder="请输入人员名称" clearable v-model="search.personName" class="input-with-select" @input="doFilter">
                                 <el-button slot="append" icon="el-icon-search" ></el-button>
                            </el-input>
                        </div>
                       </div> 
                    <el-date-picker
                        v-model="time"
                        type="daterange"     
                        align="right"
                        unlink-panels
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        style="margin-left:3vh">
                    </el-date-picker>
                    <el-button type="primary"  plain icon="el-icon-search" @click="doFilter" style="margin-left:2%;">查询</el-button>
                    <!-- <el-button type="primary" class="add-user" @click="exportWorker">考勤导出</el-button>
                    <el-button type="success" class="add-user" @click="exportWorkerDay">考勤时长导出</el-button> -->
                   <el-tooltip class="item" effect="dark" content="考勤导出" placement="top-end">
                     <div class="tips">
                      <img @click="exportWorker" class="icon_hover" src="../../assets/image/icon/exportAtt.png" alt="" srcset="" v-if="isMenuExit('pro:month:attend')">
                      <span>考勤导出</span>
                     </div>   
                   </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="考勤时长导出" placement="top-end">
                      <div class="tips">
                        <img @click="exportWorkerDay" class="icon_hover" src="../../assets/image/icon/exportTime.png" alt="" srcset="" v-if="isMenuExit('pro:month:time')">
                        <span>考勤时长导出</span>
                     </div> 
                   </el-tooltip>
                   <el-tooltip class="item" effect="dark" content="月考勤导出" placement="top-end">
                     <div class="tips" v-if="isMenuExit('pro:month:month')">
                        <img @click="exportWorkerMonth" class="icon_hover" src="../../assets/image/export.png" alt="" srcset="" >
                        <span>考勤时长导出</span>
                     </div>               
                   </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="出勤规则" placement="top-end">
                      <div class="tips"   v-if="isMenuExit('pro:month:conf')">
                        <img class="icon_hover" @click="expendVisible =true" src="../../assets/image/icon/rules.png" alt="" srcset="">
                        <span>出勤规则</span>
                     </div>  
                    </el-tooltip>
                  </div>
                  <!-- <div style="width:100%;display:flex;padding-top:1%;justify-content: space-between;"> -->
                      <!-- <div style="display:flex;align-items:center;width:50%">
                        <span>人员检索：</span>
                        <div class="table-head-seach" style="margin-right:1%;display:flex;width:50%">
                            <el-input placeholder="请输入人员名称" clearable v-model="search.personName" class="input-with-select" @input="doFilter">
                                 <el-button slot="append" icon="el-icon-search" ></el-button>
                            </el-input>
                        </div>
                       </div>  -->
                        <!-- <div style="display:flex;align-items:center">
                            <el-button type="primary" class="add-user" @click="exportWorker">考勤导出</el-button>
                            <el-button type="success" class="add-user" @click="exportWorkerDay">考勤时长导出</el-button>
                        </div>   -->
                    
                  <!-- </div>   -->             
                </div>
                <div class="table-box">
                    <el-table
                      stripe
                      border
                      ref="filterTable"
                      :data="listData"
                      height="100%"
                      style="width: 100%;"
                      :default-sort="{prop: 'createDate', order: 'descending'}"
                      :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                    >
                      <template slot="empty">
                        <p>{{dataText}}</p>
                      </template>
                      <el-table-column label="序号" width="60" fixed>
                        <template slot-scope="scope">
                          <a>{{ scope.$index+1}}</a>
                        </template>
                      </el-table-column>
                      <el-table-column label="班组" fixed width="200">
                        <template slot-scope="scope">
                          <span>{{ scope.row.teamsName }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="姓名" fixed>
                        <template slot-scope="scope">
                          <span>{{ scope.row.personName }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="出勤天数" fixed width="120">
                        <template slot-scope="scope">
                          <span style="color:#ffa603;">{{ scope.row.sum }}天</span>
                        </template>
                      </el-table-column>
                      <el-table-column v-for="item in showDays" :key="item.id" :label="item.time" width="120">
                        <template slot-scope="scope">
                          <span style="color:#409EFF;">{{ scope.row.list[item.time] }}小时</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 分页展示 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalItems"
                        style="padding-top:10px;"
                    ></el-pagination>             
                </div>
            </div>
             <el-dialog
            title=""
            :visible.sync="expendVisible"
            center
            :append-to-body="true"
            :before-close="handleClose1"
            :lock-scroll="false"
            width="30%"
          >
            <template>
                <div  style="width:70%;margin:auto">
                      <span>出勤规则：</span>
                      <el-select
                        v-model="search.minValue"
                        clearable
                        filterable
                        placeholder="请选择最小时长"
                        class="select"
                        style="width:12vh;"
                      >
                        <el-option v-for="item in startDay" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select
                        v-model="search.maxValue"
                        clearable
                        filterable
                        placeholder="请选择最大时长"
                        style="margin-left:20px;width:12vh;"
                      >
                        <el-option v-for="item in endDay" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                    </div>
                     <span slot="footer" class="dialog-footer">
                        <el-button @click=" expendVisible= false">取 消</el-button>
                        <el-button type="primary" @click="doFilter">确 定</el-button>
                      </span>
            </template>
          </el-dialog>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],//左侧班组树形结构
            defaultProps:{
                children: 'children',
                 label: 'name'
            },
            search: {//查询
                personName: '',
                fristTime:util.myTime.getweekDate()[0],
                entTime:util.myTime.getweekDate()[1],
                projectId: '',
                entId:'',
                teamsId:'',
                minValue:'0',
                maxValue:'24'
            },
            time: util.myTime.getweekDate(),
            listData: [], //表格数据
            dataText: '数据加载中...',
            pickerOptions: {
              shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            showDays:[],
            defaultEx:[],//默认打开节点
            currentPage:1,
            pageSize:100,
            totalItems:0,
            startDay: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24'],
            endDay: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24'],
            expendVisible:false,
            dialogTitle1:'',
            curKey:'',//当前选择班组
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.search.projectId = this.groupId
        this.setShowDay()
        this.getTeam()
        
    },
    methods:{
        /***
         * 获取班组
         */
        getTeam(){
            var that = this
            myHttp.getEntTeams({
                projectId: this.groupId
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    for(var i=0;i<list.length;i++){
                      if(list[i].type=='0' && that.curKey==''){
                        that.curKey = list[i].id
                        that.search.teamsId = list[i].id
                      }
                    }
                    var tree = util.common.listToTree('id', 'parentId', list)
                    var obj = [{ name: '全部', id: '0', parentId: '', children: [] }]
                    obj[0].children = tree
                    that.dataTree = obj
                    that.getData()
                    setTimeout(function(){
                      that.$refs.tree.setCurrentKey(that.curKey)
                    },100)
                }
            })
        },
        //展示日期
        setShowDay(){
          var times = this.time
          var len = util.myTime.getdayByDate(times[0],times[1])+1
          var days = []
          for(var i=0;i<len;i++){
            var time = new Date(times[0]).getTime() + 3600 * 1000 * 24 * i
            var obj = {
              name:util.myTime.getCurTime(time).split('-')[2]+'日',
              time:util.myTime.getCurTime(time)
            }
            days.push(obj)
          }
          this.showDays = days
        },
        //点击树
        handleNodeClick(data){
            // console.log(data)
            if(data.type == '1'){
              this.search.entId = data.parentId
              this.search.teamsId = ''
            }else if(data.type == '0'){
              this.search.entId = ''
              this.search.teamsId = data.id
            }else{
              this.search.entId = ''
              this.search.teamsId = ''
            }
            this.currentPage = 1
            this.getData()
        },
        //点击查询
        doFilter(){
            this.search.fristTime = this.time ? this.time[0] : ''
            this.search.entTime = this.time ? this.time[1] : ''
            this.currentPage = 1
            this.setShowDay()
            this.getData()
            this.expendVisible=false
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        //获取人员
        getData(){
            var that = this
            this.search.pageSize = this.pageSize
            this.search.pageNum = this.currentPage
            myHttp.getDayAttent(this.search).then(
              function(resp) {
                if (resp.data.code == '200') {
                  var list = resp.data.data.list.list || []
                  for(var i=0;i<list.length;i++){
                    if(list[i].StatisDay.length>0){
                      list[i].list = {}
                      for(var j=0;j<that.showDays.length;j++){
                        list[i].list[that.showDays[j].time] = that.setDataList(that.showDays[j].time,list[i].StatisDay)
                      }
                    }else{
                      list[i].list = {}
                      for(var j=0;j<that.showDays.length;j++){
                        list[i].list[that.showDays[j].time] = 0
                      }
                    }
                  }
                  that.listData = list
                  that.totalItems = resp.data.data.list.total||0
                  if (that.listData.length == 0) {
                    that.dataText = '暂无数据'
                  }
                  // console.log(list)
                  that.$refs.filterTable.doLayout()
                } else {
                  that.$message.error(resp.data.msg)
                  that.dataText = '暂无数据'
                }
              },
              function() {}
            )
        },

        setDataList(id,list){
          var result = 0
          for(var i=0;i<list.length;i++){
            if(id==list[i].dayss){
              result = list[i].workTime
            }
          }
          return result
        },

        //导出
        exportWorker(){
          var token = util.session.get('token')
          window.open(
            myHttp.exportDayAttent +
              '?projectId=' +
              this.search.projectId +
              '&personName=' +
              this.search.personName +
              '&entId=' +
              this.search.entId +
              '&teamsId=' +
              this.search.teamsId +
              '&fristTime=' +
              this.search.fristTime +
              '&entTime=' +
              this.search.entTime +
              '&minValue=' +
              this.search.minValue +
              '&maxValue=' +
              this.search.maxValue +
              '&accessToken=' +
              token
          )
        },
        //考勤时长导出
        exportWorkerDay(){
          var token = util.session.get('token')
          window.open(
            myHttp.exportDayAttentDate+
            '?entId=' + this.search.entId +
            '&teamsId='+ this.search.teamsId +
            '&personName=' + this.search.personName +
            '&fristTime=' + this.search.fristTime +
            '&entTime=' + this.search.entTime +
            '&minValue=' + this.search.minValue +
            '&maxValue=' + this.search.maxValue +
            '&projectId=' + this.search.projectId +
            '&accessToken=' + token
          )
        },
        handleClose1(){
          this.expendVisible=false
        },
        //考勤月导出
        exportWorkerMonth(){
          var token = util.session.get('token')
          var endTime = util.myTime.getDateByDays(this.search.fristTime,30)
          window.open(
            myHttp.exportDayAttentDateBySheet+
            '?entId=' + this.search.entId +
            '&teamsId='+ this.search.teamsId +
            '&personName=' + this.search.personName +
            '&fristTime=' + this.search.fristTime +
            '&entTime=' + endTime +
            '&minValue=' + this.search.minValue +
            '&maxValue=' + this.search.maxValue +
            '&projectId=' + this.search.projectId +
            '&accessToken=' + token
          )
        },
        /**
         * 判断是否展示
         */
        isMenuExit(row){
            var flag = util.common.filterBtnMenu(row)
            return flag
        },
    }
}
</script>
<style scoped>
    /* .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
    } */
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        overflow: auto;
        background: #fff;
        border-radius: 0.5vh;
        padding: 2vh;
    }
    .main-table{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .table-head{
        width: 100%;
        height: 10vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        padding: 2vh;
        /* justify-content: space-between; */
        background: #FAFAFA;
    }
    .table-head-seach{
        width: 10%;
        height: 100%;
        position: relative;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 16vh );
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
        margin-top: 0.5vh;
    }
   .box-second  >>>.el-date-editor .el-range-separator{
      padding: 0 !important;
    }
    .box-second >>>.el-input-group--append .el-input__inner{
      width: 200px;
    }
    .tips{
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
     }
    /* .main-left .is-current{
      color: #048AFA;
    } */
</style>
<style>
  @import '../../assets/css/common.css'
</style>